import React from 'react';
import PropTypes from 'prop-types';

class RoomDetail extends React.PureComponent {
  render() {
    const { room_id } = this.props;
    return(
      <div className="home">
        room_id: 
        {room_id}
      </div>
    )
  }
}

RoomDetail.defaultProps = {
};

RoomDetail.propTypes = {
  room_id: PropTypes.string.isRequired,
};

export default RoomDetail;
